import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import * as api from '../../api/app/permissionApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useTranslation } from '../../contexts/translation';
import { PermissionCreateRequest, PermissionInputs } from '../../types/app/permission.types';
import { PermissionForm } from './PermissionForm';
import { useStyles } from './PermissionForm.styles';

export function PermissionCreate() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreatePermission } = useMutation(api.createPermission);

  const defaultValues: PermissionInputs = {
    userId: null,
    identifier: null,
  };

  const convertDataFromInputToRequest = (data: PermissionInputs) => ({
    userId: data?.userId?.id ? data.userId.id : null,
    identifier: data.identifier ? data.identifier : null,
  });

  const handleOnSubmit: SubmitHandler<PermissionInputs> = (data: PermissionInputs) => {
    const requestData: PermissionCreateRequest = convertDataFromInputToRequest(data);
    mutateCreatePermission(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.permission.item-created'), { variant: 'success' });
          navigate(`/permission`);
        },
        onError: (result) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={t('page.permission.headline-create')} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} lg={3}>
            <Paper className={classes.paper}>
              <PermissionForm
                onSubmit={handleOnSubmit}
                onBack={() => navigate('/permission')}
                defaultValues={defaultValues}
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
